import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Axios from "axios";
import { Row, Col, Button, Modal } from "react-bootstrap";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as OrderDetailsStyles from "../../styles/order/orderDetails";

//COMPONENTS
import OrderDetailsItemFullPrice from "./orderDetailsItemFullPrice";
import OrderDetailsItemDeposit from "./orderDetailsItemDeposit";
import OrderDetailsRepaidItem from "./orderDetailsRepaidItem";

function OrderDetails() {
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const [orderCompleted, setOrderCompleted] = useState(false);

    const modalDefaultValues = {
        open: false
    };

    const [modal, setModal] = useState(modalDefaultValues);

    function handleModalClose() {
        setModal(modalDefaultValues);
    }

    const [details, setDetails] = useState({});
    const [items, setItems] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("3D Printing Service - Order Details"));
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("3D Printing Service"));

        loadData();
    }, [params.id]);

    function loadData() {
        const data = { id: params.id };
        Axios.post("/pods/3dPrintingShop/orders/getOrderDetails", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    setDetails(data.details);
                    setItems(data.items);
                    setOrderCompleted(data.orderCompleted);
                    setLoaded(true);
                }
            })
            .catch((err) => console.log(err));
    }

    function handlePrintingProgressClick() {
        navigate("./printingProgress");
    }

    function handleViewOrderConfirmination() {
        const data = { orderID: details.uuid };

        Axios.post("/pods/3dPrintingShop/orders/produceOrderConfirmationPDF", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setModal((prevState) => {
                        return { ...prevState, open: true };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function pdfLoaded(filename) {
        const data = { filename: filename };

        Axios.post("/pods/onlinePayments/deleteTempPDF", data)
            .then((res) => {
                const data = res.data;
            })
            .catch((err) => console.log(err));
    }

    function handleSendDispatchInfo(orderUUID) {
        const data = { orderUUID: orderUUID };
        Axios.post("/pods/3dPrintingShop/checkout/sendDispatchInfo", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    loadData();
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={OrderDetailsStyles.body}>
            {loaded && (
                <div>
                    <Row>
                        <Col>
                            <Row>
                                <Col style={OrderDetailsStyles.columnRight}>
                                    <strong>Order ID:</strong> {details.id}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <strong>Customer:</strong> {details.userDetails.fullName} <br />
                                    <strong>Email: </strong> {details.userDetails.email} <br />
                                    <strong>Telephone: </strong> {details.userDetails.tel} <br /> <br />
                                    <strong>Address: </strong> <br />
                                    {details.userDetails.addressLine1} <br />
                                    {details.userDetails.addressLine2} <br />
                                    {details.userDetails.town} <br />
                                    {details.userDetails.postcode} <br />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <br />
                                    {details.depositItems && (
                                        <div style={OrderDetailsStyles.redText}>
                                            This order contain items which you are paying deposits for. The remianing ammount will be due when half
                                            the the model is built
                                        </div>
                                    )}
                                </Col>
                                <Col>
                                    <Row>
                                        <Col style={OrderDetailsStyles.columnRight}>
                                            <strong>Sub Total:</strong>
                                        </Col>
                                        <Col sm={4}>£{(details.subTotal / 100).toFixed(2)}</Col>
                                    </Row>
                                    <br />
                                    {details.coupon.active && (
                                        <div>
                                            <Row>
                                                <Col style={OrderDetailsStyles.columnRight}>
                                                    <strong>Coupon: </strong>
                                                    {details.coupon.code} ({details.coupon.description}):
                                                </Col>
                                                <Col sm={4}>-£{(details.coupon.takenOffAmount / 100).toFixed(2)}</Col>
                                            </Row>
                                            <br />
                                        </div>
                                    )}
                                    <Row>
                                        <Col style={OrderDetailsStyles.columnRight}>
                                            <strong>Postage:</strong>
                                        </Col>
                                        <Col sm={4}>
                                            {details.postage.name} (£{(details.postageWhenOrdered / 100).toFixed(2)})
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col style={OrderDetailsStyles.columnRight}>
                                            <strong>Total:</strong>
                                        </Col>
                                        <Col sm={4}>£{(details.orderTotal / 100).toFixed(2)}</Col>
                                    </Row>
                                    {details.depositItems ? (
                                        <div>
                                            <hr />
                                            <Row>
                                                <Col style={OrderDetailsStyles.columnRight}>
                                                    <strong>Full Order Total:</strong>
                                                </Col>
                                                <Col sm={4}>£{(details.subTotalWithoutDeposits / 100).toFixed(2)}</Col>
                                            </Row>
                                            <Row>
                                                <Col style={OrderDetailsStyles.columnRight}>
                                                    <strong>Amount Paid:</strong>
                                                </Col>
                                                <Col sm={4}>£{(details.subTotal / 100).toFixed(2)}</Col>
                                            </Row>
                                            <Row style={OrderDetailsStyles.redText}>
                                                <Col style={OrderDetailsStyles.columnRight}>
                                                    <strong>Outstanding Amount:</strong>
                                                </Col>
                                                <Col sm={4}>£{(details.toPay / 100).toFixed(2)}</Col>
                                            </Row>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </Col>
                            </Row>
                            {orderCompleted && (
                                <div>
                                    {details.status == "Dispatched" ? (
                                        <div>
                                            <Row>
                                                <Col style={OrderDetailsStyles.awaitDispatch}>Dispatched</Col>
                                            </Row>
                                        </div>
                                    ) : (
                                        <div>
                                            {" "}
                                            <Row>
                                                <Col style={OrderDetailsStyles.awaitDispatch}>Awaiting to be Dispatched</Col>
                                            </Row>
                                        </div>
                                    )}
                                </div>
                            )}
                            <Row>
                                <Col>
                                    <strong>Items:</strong>
                                    <br /> <br />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {items.map((item, index) => {
                                        if (item.priceStatus == "dp") {
                                            if (item.repaidItem) {
                                                return <OrderDetailsRepaidItem key={index} item={item} />;
                                            } else {
                                                return <OrderDetailsItemDeposit key={index} item={item} />;
                                            }
                                        } else {
                                            return <OrderDetailsItemFullPrice key={index} item={item} />;
                                        }
                                    })}
                                </Col>
                            </Row>
                        </Col>
                        <Col sm={3} style={OrderDetailsStyles.buttons}>
                            <Button onClick={handlePrintingProgressClick}>Printing Progress</Button>
                            <Button onClick={handleViewOrderConfirmination}>View Order Confirmation</Button>
                            {orderCompleted && details.status != "Dispatched" && (
                                <div>
                                    <Button onClick={handleSendDispatchInfo.bind(this, details.uuid)}>Send Dispatched Info</Button>
                                    <br /> <br />
                                    {details.postage.emailType == "byPost" ? (
                                        <div>This order is set to be posted</div>
                                    ) : (
                                        <div>This order is set to be picked up</div>
                                    )}
                                </div>
                            )}
                        </Col>
                    </Row>
                </div>
            )}
            <Modal size="lg" show={modal.open} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Order Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        id="iframepdf"
                        width="100%"
                        height="500"
                        src={`${window.location.origin}/content/temp/test.pdf`}
                        onLoad={pdfLoaded.bind(this, "test.pdf")}
                    ></iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleModalClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default OrderDetails;
